// extracted by mini-css-extract-plugin
export default {"dialogContent":"SendToAllUsers_dialogContent__ajVwV"};